import React from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'components/Shared/Table'
import { columns } from 'components/Groups/GroupsTable/columns'
import { deleteGroup, fetchGroupsPage } from 'services/GroupsService'
import { HTTP_404_ERROR } from 'Constants'
import { useErrorHandling } from 'context/errorHandling'
import { useAuth, GROUP_CREATE, GROUP_DELETE, GROUP_EDIT } from 'context/auth'

export function GroupsTable () {
  const history = useHistory()
  const { hasAnyPrivileges } = useAuth()
  const { handleError } = useErrorHandling()

  const addGroup = () => {
    history.push('/groups/create')
  }

  const editGroup = (row) => {
    if (!hasAnyPrivileges([GROUP_EDIT])) return
    history.push('/groups/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    handleError(error, {
      [HTTP_404_ERROR]: 'notifications.error.delete'
    })
  }

  const copyGroup = row => {
    history.push({
      pathname: '/groups/create',
      state: { idOfCopiedGroup: row.id }
    })
  }

  const addButton = {
    label: 'groups.table.addButtonLabel',
    onClick: addGroup,
    isClickable: hasAnyPrivileges([GROUP_CREATE])
  }

  const menuOptions = {
    copy: {
      onClick: copyGroup,
      isCopyable: () => hasAnyPrivileges([GROUP_CREATE])
    },
    delete: {
      onDelete: deleteGroup,
      onDeleteError: onDeleteError,
      deleteDialog: {
        content: 'groups.table.deleteDialog.content',
        title: 'groups.table.deleteDialog.title'
      },
      isDeletable: () => hasAnyPrivileges([GROUP_DELETE])
    }
  }

  return (
    <Table title={'groups.table.title'}
           addButton={addButton}
           fetchData={fetchGroupsPage}
           columns={columns}
           tableKey={'groups'}
           onRowClick={editGroup}
           menu={menuOptions}
    />
  )
}
